import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import PullToRefresh from '../../components/PullToRefresh/PullToRefresh';
import FoodTruckSideBar from './FoodTruckSideBar/FoodTruckSideBar';
import FoodTruckTopBar from './FoodTruckTopBar/FoodTruckTopBar';

const FoodTruckLayout = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', marginY: '40px' }}>
      <FoodTruckTopBar />
      <Box sx={{ display: 'flex', height: 'calc(100vh - 224px)' }}>
        <FoodTruckSideBar />
        <PullToRefresh>
          <Box
            sx={{
              height: 'calc(100vh - 224px)',
              overflowY: 'auto',
              width: '100%',
            }}
          >
            <Outlet />
          </Box>
        </PullToRefresh>
      </Box>
    </Box>
  );
};
export default FoodTruckLayout;
